import request from "../../utils/request";
import _ from "lodash";

export default {
    namespaced: true,
    state: {
        trigger: [],
        skeletonLoading: true,
    },
    mutations: {
        ADD_TRIGGER(state, payload) {
            state.trigger.push(payload);
        },
        SET_TRIGGER(state, payload) {
            state.trigger = _.sortBy(payload, (x) => x.order);
            state.skeletonLoading = false;
        },
        UPDATE_TRIGGER(state, payload) {
            const index = state.trigger.findIndex((trigger) => trigger._id === payload._id);
            state.trigger[index] = payload;
            state.trigger = _.sortBy(state.trigger, (x) => x.order);
        },
        DELETE_TRIGGER(state, payload) {
            const index = state.trigger.findIndex((trigger) => trigger._id === payload._id);
            state.trigger.splice(index, 1);
        },
    },
    actions: {
        async addTrigger({ commit }, payload) {
            try {
                const response = await request.post("/trigger", payload);
                commit("ADD_TRIGGER", response.data);
            } catch (error) {
                console.error(error);
                return error;
            }
        },
        async getTrigger({ commit }) {
            try {
                const response = await request.get("/trigger");
                commit("SET_TRIGGER", response.data);
            } catch (error) {
                console.error(error);
            }
        },
        async updateTrigger({ commit }, payload) {
            try {
                const response = await request.patch("/trigger", payload);
                commit("UPDATE_TRIGGER", response.data);
            } catch (error) {
                console.error(error);
                return error;
            }
        },
        async deleteTrigger({ commit }, payload) {
            try {
                await request.delete(`/trigger/${payload._id}`);
                commit("DELETE_TRIGGER", payload);
            } catch (error) {
                console.error(error);
                return error;
            }
        },
    },
};
